module.exports = __webpack_public_path__ + "img/pressure_blue.a5f1d288.svg";